import { useState } from "react";
import "./Home.css";

import TemplateCarousel from "../TemplateCarousel/TemplateCarousel";
import Carousel from "../Carousel/Carousel";
import CardTemplate from "../CardTemplate/CardTemplate";
import ResizeImage from "../ResizeImage/ResizeImage";
import ResizeText from "../ResizeText/ResizeText";
import DownloadButton from "../DownloadButton/DownloadButton";
import TemplateData from "../../data/TemplateData";
import CarouselData from "../../data/CarouselData";
import ColorPicker from "../ColorPicker/ColorPicker";
import TextInput from "../TextInput/TextInput";
import FontSizePicker from "../FontSizePicker/FontSizePicker";
import FontPicker from "../FontPIcker/FontPicker";
import FontWeightPicker from "../FontWeight/FontWeight";

import TemplateOrientation from "../TemplateOrientation/TemplateOrientation";
import TemplateDataPortrait from "../../data/TemplateDataPortrait";
import UploadImage from "../UploadImage/UploadImage";
import UploadTemplate from "../UploadTemplate/UploadTemplate";
import Category from "../Category/Category";
import ClearButton from "../ClearButton/ClearButton";
import Footer from "../Footer/Footer";

const Home = () => {
  const [message, setMessage] = useState("");

  const [images, setImageUrls] = useState([]);

  console.log("all images", images);

  const [template, setTemplateUrl] = useState(
    TemplateDataPortrait[
      Math.floor(Math.random() * TemplateDataPortrait.length)
    ]
  );

  const [textColor, setTextColor] = useState();
  const [fontSize, setFontSize] = useState(14);
  const [textFont, setTextFont] = useState("Arial");
  const [fontWeight, setFontWeight] = useState(400);
  const [orientation, setOrientation] = useState("portrait");
  const [category, setCategory] = useState("animals");
  const [clearButtonClicked, setClearButtonClicked] = useState(false);

  return (
    <div className="container is-fluid">
      <div className="columns is-vcentered">
        <div className="column is-5">
          <h1 className="category">Template</h1>
          <TemplateOrientation
            onOrientationChange={(orientation) => setOrientation(orientation)}
          />

          <TemplateCarousel
            onClickTemplate={(template) => setTemplateUrl(template)}
            orientation={orientation}
          />
          <h1 className="category">Category</h1>
          
          <Category onCategoryChange={(category) => setCategory(category)} images={images}/>
          
          <div className="card-buttons">
          <UploadTemplate onUploadTemplate={(template) => setTemplateUrl(template)}/>
          <UploadImage images={images} onUploadImages={(images) => setImageUrls(images)}/>
          </div>
          
          <h1 className="category">Image</h1>
          <h3>Click on image to add it on your card</h3>
         
        <Carousel
            onClickImage={(images) => setImageUrls(images)}
            images={images}
            category={category}
          /> 
        </div>

        <div className="column is-2 middle">
          <div className="card is-shadowless">
            <div className="content">
              <div>
                <h1 className="category">Message</h1>
                <TextInput
                  onTextChange={(message) => setMessage(message)}
                  color={textColor}
                />
              </div>
            </div>
          </div>

          <div className="card is is-shadowless">
            <div className="content">
              <div>
                <h1 className="category">Fonts</h1>
                <FontPicker onFontChange={(font) => setTextFont(font)} />
              </div>
            </div>
          </div>

          <div className="is-shadowless">
            <div className="content">
              <div>
                <h1 className="category">Font Sizes</h1>
                <FontSizePicker
                  onFontSizeChange={(fontSize) => setFontSize(fontSize)}
                />
              </div>
            </div>
          </div>

          <div className="is-shadowless">
            <div className="content">
              <div>
                <h1 className="category">Font Weights</h1>
                <FontWeightPicker
                  onFontWeightChange={(fontWeight) => setFontWeight(fontWeight)}
                />
              </div>
            </div>
          </div>

          <div className="is-shadowless">
            <div className="content">
              <div>
                <h1 className="category">Colours</h1>
                <ColorPicker
                  onColorChange={(textColor) => setTextColor(textColor)}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="column is-6">
          <h1 className="category">Design</h1>
          <ol>
            <li>
              Select an orientation for a template: portrait or landscape
            </li>
            <li>
              Select a desired template from the top carousel by clicking on it
              or upload template from your computer
            </li>
            <li>
              Select an image category and choose an image from the bottom
              carousel or upload image from your computer
            </li>
            <li>You can select as many images as you like</li>
            <li>You can drag or resize your images</li>
            <li>
              Customise your message by selecting a font, a font size, and a colour
            </li>
            <li>Download your unique card to your computer</li>
          </ol>
          <div className="card-to-display">
            <CardTemplate templateUrl={template} />
            {images.map((url) => (
              <ResizeImage image={url} />
            ))}

            <ResizeText
              message={message}
              color={textColor}
              fontSize={fontSize}
              font={textFont}
              fontWeight={fontWeight}
            />
          </div>
          <div className="card-buttons">
            <ClearButton
              onClearButtonClick={() => setClearButtonClicked(true)}
              setImageUrls={() => setImageUrls([])}
              setMessage={() => setMessage("")}
            />
            <DownloadButton />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
